import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';

const LegalPage = ({ title, children }) => (
  <Container maxWidth="md" sx={{ py: { xs: 10, md: 14 }, px: { xs: 2, sm: 3 } }}>
    <Button
      component={RouterLink}
      to="/"
      startIcon={<ArrowBackIcon />}
      sx={{ mb: 3 }}
    >
      Volver al inicio
    </Button>
    <Paper sx={{ p: { xs: 2.5, sm: 3, md: 5 }, overflowWrap: 'anywhere' }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        fontWeight={700}
        sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}
      >
        {title}
      </Typography>
      <Box sx={{ '& p': { mb: 2, lineHeight: 1.8, color: 'text.secondary', overflowWrap: 'anywhere' } }}>
        {children}
      </Box>
    </Paper>
  </Container>
);

export default LegalPage;
